import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';
//import { messaging } from './firebaseConfig';

import { BleProvider } from './ble/BleContext';

// React 19 REMOVED the legacy `ReactDOM.render` entry point. This file used it until
// 2026-08-05, when AUD-DEP-13 bumped react/react-dom to ^19.2.8 without migrating here —
// the app then failed to mount at all, leaving the static placeholder in <div id="root">
// ("If you see this message, likely you are using a Facebook mobile app embedded browser").
//
// The failure is quiet in a way that is worth remembering: webpack compiles clean, bundle.js
// serves 200, and nothing in the build output complains. Only the rendered page is wrong.
// Do not reintroduce `ReactDOM.render` / `react-dom`'s default export.
const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <BleProvider>
      <App />
    </BleProvider>
  </React.StrictMode>
);
